import React from 'react';
import PropTypes from 'prop-types';


import FormSelect from '../../../global/Form/FormElement/FormSelect';
import LanguageSelectForm from '../LanguageSelectForm';
import useSourceContentLanguages from '../hooks/useSourceContentLanguages';


function SourceLanguageSelectForm(props) {

    const sourceContentLanguages = useSourceContentLanguages();

    return (
        <LanguageSelectForm
            languages={sourceContentLanguages}
            {...props}
        />
    );
}


SourceLanguageSelectForm.propTypes = {
    ...FormSelect.propTypes,
    value: PropTypes.string
};


SourceLanguageSelectForm.defaultProps = {
    ...FormSelect.defaultProps
};


export default SourceLanguageSelectForm;
